import React, { FunctionComponent, useMemo } from 'react';
import { Container, createArrayInRange } from '@visalex/core';

import { useTranslation } from 'next-i18next';

import GreenCard, { GreenCardColumn, GreenCardProps } from './GreenCard/GreenCard';

import styles from './TypesOfGreenCard.module.scss';

const greenCardLinks = ['/green-cards/family-based', '/green-cards/employment-based', '/green-cards/investment-based'];

const prefix = 'green-cards.cards';
const TypesOfGreenCard: FunctionComponent = () => {
  const { t, i18n } = useTranslation();

  const greenCardProps = useMemo(
    () =>
      createArrayInRange(0, 2).map((index) => ({
        title: t(`${prefix}.${index}.title`),
        description: t(`${prefix}.${index}.description`),
        imageUrl: t(`${prefix}.${index}.imageUrl`),
        imageAlt: t(`${prefix}.${index}.imageAlt`),
        subtitle: t(`${prefix}.${index}.subtitle`),
        columns: t(`${prefix}.${index}.columns`, { returnObjects: true }) as GreenCardColumn[],
        link: `${greenCardLinks[index]}`,
      })),
    [i18n.language]
  );

  return (
    <section className={styles['types-of-green-card']}>
      <Container className={styles['cards-container']}>
        {greenCardProps.map((cardProps: GreenCardProps, index: number) => {
          return <GreenCard {...cardProps} key={index} />;
        })}
      </Container>
    </section>
  );
};

export default TypesOfGreenCard;
